import {
  AfterViewInit,
  Component,
  ElementRef,
  OnInit,
  ViewChild,
} from "@angular/core";
import { FeaturesBaseComponent } from "src/app/features-common/components/features-base.component";
import Quill from "quill";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import * as moment from "moment";
import { PromotionsService } from "src/app/features/promotions/promotions.service";
import { DialogComponent } from "src/app/features-common/components/dialog/dialog.component";
import { forkJoin } from "rxjs";
import { Router } from "@angular/router";
import { MatDialog } from "@angular/material/dialog";

@Component({
  selector: "app-add-consumer-banner",
  templateUrl: "./add-consumer-banner.component.html",
  styleUrls: ["./add-consumer-banner.component.scss"],
})
export class AddConsumerBannerComponent
  extends FeaturesBaseComponent
  implements OnInit, AfterViewInit
{
  consumerPromotionForm: FormGroup;
  skulist: any = [];
  promotionsCarriers: any = [];
  serviceCountries: any;
  fileToUpload: File;
  codeGroups: [];

  constructor(
    private promotionService: PromotionsService,
    private router: Router,
    private dialog: MatDialog
  ) {
    super();
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.consumerPromotionForm = new FormGroup({
      promotionName: new FormControl("", []),
      promotionHeader: new FormControl("", [Validators.required]),
      promotionDescription: new FormControl("", [Validators.required]),
      promotionNameText: new FormControl("", []),
      promotionDescriptionText: new FormControl("", []),
      promotionNameApp: new FormControl("", [Validators.required]),
      promotionDescriptionApp: new FormControl("", [Validators.required]),
      additionalInfo: new FormControl("", []),
      minTopUpAmount: new FormControl(""),
      vendorName: new FormControl(""),
      promotionStartdttm: new FormControl("", [Validators.required]),
      promotionEnddttm: new FormControl("", [Validators.required]),
      applicableMinAmount: new FormControl("", [Validators.required]),
      applicableMaxAmount: new FormControl("", [Validators.required]),
      tilaCodeGroup: new FormControl("", [Validators.required]),
      tilaCountry: new FormControl("", [Validators.required]),
      tilaCarrier: new FormControl("", [Validators.required]),
      tilaProductId: new FormControl("", [Validators.required]),
      isCertified: new FormControl(true, null),
      videoUrl: new FormControl(""),
    });
    this.getAllProductServiceData();
  }

  get f() {
    return this.consumerPromotionForm.controls;
  }

  ngAfterViewInit(): void {}

  handleFileInput(files: FileList) {
    this.fileToUpload = files.item(0);
  }

  onCheckCertify(e) {
    //alert(e.value)
  }

  onCarrierFormSubmit(e) {
    if (this.consumerPromotionForm.valid) {
      const dialogRef = this.dialog.open(DialogComponent, {
        data: {
          message: "pages.placeholders.Areyousureyouwanttosavethechanges",
          buttonText: {
            ok: "pages.placeholders.Save",
            cancel: "pages.placeholders.cancel",
          },
        },
      });

      dialogRef.afterClosed().subscribe((confirmed: boolean) => {
        if (confirmed) {
          this.setSubmitParameters();
        } else {
          // this.router.navigate(['features/consumers/consumer-banner/manage-banner'])
        }
      });
    }
  }

  /**
   * save the promotion details
   */
  setSubmitParameters() {
    const formData: FormData = new FormData();
    formData.append(
      "editedPromotionName",
      this.consumerPromotionForm.get("promotionName")?.value
    );
    formData.append(
      "promotionHeaderEnglish",
      this.consumerPromotionForm.get("promotionHeader")?.value
    );
    formData.append(
      "editedPromotionDescription",
      this.consumerPromotionForm.get("promotionDescription")?.value
    );
    formData.append(
      "editedPromotionNameTxtMsg",
      this.consumerPromotionForm.get("promotionNameText")?.value
    );
    formData.append(
      "editedPromotionDescTxtMsg",
      this.consumerPromotionForm.get("promotionDescriptionText")?.value
    );
    formData.append(
      "editedPromotionNameApp",
      this.consumerPromotionForm.get("promotionNameApp")?.value
    );
    formData.append(
      "editedPromotionDescApp",
      this.consumerPromotionForm.get("promotionDescriptionApp")?.value
    );
    formData.append(
      "additionalInfo",
      this.consumerPromotionForm.get("additionalInfo")?.value
    );
    formData.append(
      "vendorName",
      this.consumerPromotionForm.get("vendorName")?.value
    );
    formData.append("promotionImage", this.fileToUpload);
    formData.append(
      "promotionStartdttm",
      moment(this.consumerPromotionForm.get("promotionStartdttm").value).format(
        "MM/DD/YYYY"
      )
    );
    formData.append(
      "promotionEnddttm",
      moment(this.consumerPromotionForm.get("promotionEnddttm").value).format(
        "MM/DD/YYYY"
      )
    );
    formData.append(
      "applicableMinAmount",
      this.consumerPromotionForm.get("applicableMinAmount")?.value
    );
    formData.append(
      "applicableMaxAmount",
      this.consumerPromotionForm.get("applicableMaxAmount")?.value
    );
    formData.append(
      "tilaCodeGroup",
      this.consumerPromotionForm.get("tilaCodeGroup")?.value
    );
    formData.append(
      "tilaCountry",
      this.consumerPromotionForm.get("tilaCountry")?.value
    );
    formData.append(
      "tilaCarrier",
      this.consumerPromotionForm.get("tilaCarrier")?.value
    );
    formData.append(
      "tilaProductId",
      this.consumerPromotionForm.get("tilaProductId")?.value
    );
    formData.append(
      "isCertified",
      this.consumerPromotionForm.get("isCertified").value ? "Yes" : "No"
    );
    formData.append(
      "videoUrl",
      this.consumerPromotionForm.get("videoUrl")?.value
    );
    formData.append(
      "minTopUpAmount",
      this.consumerPromotionForm.get("minTopUpAmount")?.value
    );

    this.promotionService.postConsumerPromotions(formData).subscribe({
      next: (res) => {
        if (res.responseStatus == "Success") {
          this.router.navigate([
            "features/consumers/consumer-banner/manage-banner",
          ]);
          this.toastrService.success(
            "Consumer Promotion added successfully",
            "Success",
            {
              timeOut: 3000,
            }
          );
        }
      },
    });
  }

  onCancel() {
    const dialogRefCancel = this.dialog.open(DialogComponent, {
      data: {
        message: "pages.placeholders.Areyousureyouwanttocancelthechanges",
        buttonText: {
          ok: "pages.newRetailer.yes",
          cancel: "pages.newRetailer.cancel",
        },
      },
    });

    dialogRefCancel.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {
        this.router.navigateByUrl(
          "features/consumers/consumer-banner/manage-banner"
        );
      }
    });
  }

  getCountries(e) {
    let CodeGroup = this.consumerPromotionForm.get("tilaCodeGroup").value;
    this.promotionService.getCountries(CodeGroup).subscribe((res) => {
      let _carriers: any = res;
      if (_carriers.httpcode == 200) {
        this.serviceCountries = _carriers.data;
        this.promotionsCarriers = [];
        this.skulist = [];
      }
    });
  }

  getCarriersList(e) {
    let CodeGroup = this.consumerPromotionForm.get("tilaCodeGroup").value;
    let country = this.consumerPromotionForm.get("tilaCountry").value;
    this.promotionService
      .getCarriersList(CodeGroup, country)
      .subscribe((res) => {
        let _carriers: any = res;
        if (_carriers.httpcode == 200) {
          this.promotionsCarriers = _carriers.data;
          this.skulist = [];
        }
      });
  }

  getcarriers(e) {
    ///getcarriers
    let country = this.consumerPromotionForm.get("tilaCountry").value;
    let CodeGroup: any = Array();
    CodeGroup.push(this.consumerPromotionForm.get("tilaCodeGroup").value);
    this.promotionService
      .getCarrierNamesbycountrycodegroup(country, CodeGroup)
      .subscribe((res) => {
        let _carriers: any = res;
        if (_carriers.httpcode == 200) {
          this.promotionsCarriers = _carriers.data;
        }
      });
  }

  getsku(e) {
    ///getcarriers
    let country = this.consumerPromotionForm.get("tilaCountry").value;
    let CodeGroup = this.consumerPromotionForm.get("tilaCodeGroup").value;
    let carrier = this.consumerPromotionForm.get("tilaCarrier").value;

    this.promotionService
      .getConsumerSkuList(country, CodeGroup, carrier)
      .subscribe((res) => {
        let _carriers: any = res;
        if (_carriers.httpcode == 200) {
          this.skulist = _carriers.data;
        }
      });
  }

  getAllProductServiceData() {
    let codeGroups = this.promotionService.getcodeGroups();
    let serviceCountries = this.promotionService.getCarrierCountries();

    forkJoin([codeGroups, serviceCountries]).subscribe((res) => {
      this.codeGroups = res[0].data;
      this.serviceCountries = res[1]["data"];
    });
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }
}
